import { useField, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCorrectLink, TranslatedText } from "../../../helpers/helpers";
import getMenuConfig from "../../../helpers/menuConfig";
import Modal from "../../common/Modal/Modal";
import SummaryItem from "../components/SummaryItem/SummaryItem";

export default function CheckboxField(props) {
  const {
    pdfLinks: { aggiornaPrivacy },
  } = getMenuConfig();
  const pdfLink = getCorrectLink(aggiornaPrivacy);
  const {
    label,
    privacy,
    onChange,
    optionalLabel,
    onInitialize,
    validationSchema,
    ...rest
  } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;
  const { values, setFieldValue } = useFormikContext();
  const { summaryMode } = rest;
  const { t } = useTranslation();
  const [showInfoModal, setShowInfoModal] = useState(false);
  const isRequired = validationSchema?.fields[field.name]?._exclusive?.required;
  useEffect(() => {
    if (onInitialize) {
      onInitialize(field.value);
    }
  });
  const handleToggle = () => {
    if (onChange) {
      onChange(field.value, values, setFieldValue);
    }

    if (field.value === false) {
      setValue(true);
    } else {
      setValue(false);
    }
  };
  const summaryLabel =
    typeof label === "object" ? t(label.props.i18nKey) : label;
  return (
    <div className="form-group checkbox-group">
      {!summaryMode ? (
        <div
          className={
            meta.touched && meta.error
              ? "form-check abc-checkbox is-invalid"
              : "form-check abc-checkbox"
          }
        >
          <input
            type="checkbox"
            id={field.name}
            name={field.name}
            onChange={handleToggle}
            checked={field.value}
            className="form-check-input"
            required={isRequired}
          />
          <label className="form-check-label" htmlFor={field.name}>
            {privacy ? (
              <p>
                <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_1" />
                <a
                  className="link-a"
                  target="_blank"
                  rel="noopener noreferrer"
                  href={getCorrectLink(pdfLink)}
                >
                  <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_2" />{" "}
                  <span className="sr-only">{t("form.privacy.label.pdf")}</span>
                </a>{" "}
                <span>
                  <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_3" />
                </span>{" "}
                <span>
                  <b>
                    <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_4" />
                  </b>
                </span>{" "}
                <span>
                  <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_5" />
                </span>{" "}
                <span>
                  <b>
                    <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_6" />
                  </b>
                </span>{" "}
                <span>
                  <TranslatedText i18nKey="cases.aggiorna.dati.step1.2.privacy.label_7" />
                </span>
              </p>
            ) : (
              label
            )}
          </label>
          {field.name === "volturaMortisCausa" ? (
            <button
              type="button"
              className={"form-info-button"}
              aria-label={t("aria.form.info.button")}
              aria-haspopup="dialog"
              aria-controls={field.name + "-info-modal"}
              onClick={() => {
                setShowInfoModal(true);
              }}
            >
              {" "}
              <span className="form-icon-info" aria-hidden="true"></span>
            </button>
          ) : (
            ""
          )}
          {optionalLabel ? (
            <div
              style={{
                fontStyle: "italic",
                fontSize: "1rem",
                paddingTop: "10px",
              }}
            >
              {t("form.privacy.label.optional")}
            </div>
          ) : null}

          <Modal
            show={showInfoModal}
            onClose={() => setShowInfoModal(false)}
            type={"button"}
            linkTitle={t("common.hoCapito")}
            onFirstClick={() => setShowInfoModal(false)}
            description={t(
              "cases.voltura.fields.mortis_causa.info_modal_message"
            )}
          />
          {meta.touched && meta.error ? (
            <p
              className="form-error-text paragraph-small-form"
              role="alert"
              id={field.name + "-error"}
            >
              {meta.error}
            </p>
          ) : null}
        </div>
      ) : (
        <>
          <span
            className="paragraph-small-fs9"
            style={{ display: summaryLabel ? "block" : "none" }}
          >
            {summaryLabel}
          </span>
          <SummaryItem
            value={field.value ? t("common.yes") : t("common.no")}
            error={meta.error}
          />
        </>
      )}
    </div>
  );
}
